import axios from 'axios';
import history from './history';

    // Add a request interceptor
    axios.interceptors.request.use(async config => {
      if (config.url === "/api/account/refreshtoken" || config.url === "/api/account/login" ||
       config.url === "/api/create-checkout-session" || config.url === "/api/finish-checkout-session"
       || config.url === "/api/reset" || config.url === "/api/confirm" || config.url === "/api/account/forgot"
       || config.url.split('?')[0]  === "/api/scan") {// Early return for refreshes
        return config;
      }
      
      config.headers.Authorization = localStorage.getItem("token");
      if(localStorage.getItem("token") === null && localStorage.getItem("refresh_token") === null){
        history.push('login');
        return config;
      }
      if (localStorage.getItem("expires") < Math.floor(Date.now() / 1000)){
        const response = await axios.post('/api/account/refreshtoken', {refresh_token: localStorage.getItem("refresh_token")})
        .then(function (response) {
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("expires", response.data.expires);
          localStorage.setItem("refresh_token", response.data.refresh_token);          
          config.headers.Authorization = response.data.token;
        }).catch(function (error) {
          if (!history.location.pathname.includes("login")){
          localStorage.setItem("lastlink", history.location.pathname);
          }
          history.push('login');
        });
      }
      return config;
    });